import moment from "moment-timezone";

export function normalizeTimeZone(value) {
  const candidates = typeof value === "string" ? [value] : [value?.value, value?.name];
  return candidates.find((name) => typeof name === "string" && moment.tz.zone(name)) || "";
}

export function deviceTimeZone() {
  return normalizeTimeZone(Intl.DateTimeFormat().resolvedOptions().timeZone) || moment.tz.guess(true) || "UTC";
}

export function timeZoneLabel(zone) {
  if (zone === "America/St_Johns") return "St. John's";
  if (zone === "Asia/Kolkata" || zone === "Asia/Calcutta") return "India";
  return (zone || "UTC").split("/").pop().replaceAll("_", " ");
}

export function timeZoneOffset(zone, date) {
  return `UTC${moment.tz(date || undefined, zone).format("Z")}`;
}
